// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_account_sharing_model from "./web_account_sharing_model.js";
import * as Mapre_web__Web_accounts_model from "./web_accounts_model.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function emit(t, action) {
  Curry._1(t.emit, {
    TAG: /* Accounts */ 41,
    _0: {
      TAG: /* Sharing */ 15,
      _0: action
    }
  });
}

function form(t) {
  return Stdlib__Option.bind(Curry._1(t.model, undefined).account_form, (function (p) {
    return p.sharing;
  }));
}

function accounts(t) {
  return Stdlib__Option.fold(/* [] */ 0, (function (p) {
    return p.items;
  }), Curry._1(t.model, undefined).account_form);
}

function account(t, id) {
  return Stdlib__List.find_opt((function (p) {
    return p.id === id;
  }), accounts(t));
}

function cancel(t) {
  t.generation = t.generation + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
}

function active(t, generation, id) {
  if (generation === t.generation) {
    return Stdlib__Option.fold(false, (function (p) {
      return p.account_id === id;
    }), form(t));
  } else {
    return false;
  }
}

function failure(t, error) {
  if (!/* tag */ (typeof error !== "object" && typeof error !== "function")) {
    return emit(t, {
      TAG: /* Failed */ 5,
      _0: error._0
    });
  }
  switch (error) {
    case /* Unauthorized */ 0 :
      return Curry._1(t.failure, error);
    case /* Forbidden */ 1 :
      return emit(t, {
        TAG: /* Failed */ 5,
        _0: "Sharing permission changed. Refresh sharing."
      });
    case /* Invalid_response */ 2 :
      return emit(t, {
        TAG: /* Failed */ 5,
        _0: "Invalid sharing response."
      });
  }
}

function request(t, id, method_, body, suffix, consume) {
  const generation = t.generation;
  Mapre_web__Browser.request(t.controller, method_, body, "/api/connections/" + (id + suffix)).then(function (result) {
    if (active(t, generation, id)) {
      if (result.TAG === /* Ok */ 0) {
        try {
          Curry._1(consume, result._0);
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            emit(t, {
              TAG: /* Failed */ 5,
              _0: "Invalid sharing response."
            });
          } else {
            throw exn;
          }
        }
      } else {
        failure(t, result._0);
      }
    }
    return Promise.resolve();
  });
}

function load(t, account, more) {
  const cursor = Stdlib__Option.bind(form(t), (function (p) {
    return p.cursor;
  }));
  cancel(t);
  emit(t, {
    TAG: /* Loading */ 2,
    _0: account.id,
    _1: account.label,
    _2: more
  });
  const suffix = "/workspaces" + (
    more ? Stdlib__Option.fold("", (function (id) {
        return "?after_id=" + id;
      }), cursor) : ""
  );
  request(t, account.id, undefined, undefined, suffix, (function (json) {
    const current = Mapre_web__Web_accounts_model.decode(Mapre_wire__Json.get(json, "connection"));
    if (current.id !== account.id) {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "unexpected_connection"
        });
    }
    const items = Stdlib__Array.to_list(Stdlib__Array.map(Mapre_web__Web_account_sharing_model.decode, Mapre_wire__Json.array(json, "workspaces")));
    const cursor = Caml_obj.caml_equal(Mapre_wire__Json.get(json, "next_cursor"), null) ? undefined : Mapre_wire__Json.string(json, "next_cursor");
    Curry._1(t.emit, {
      TAG: /* Accounts */ 41,
      _0: {
        TAG: /* Updated */ 14,
        _0: current
      }
    });
    if (current.status === "revoked") {
      return emit(t, /* Close */ 0);
    } else {
      return emit(t, {
        TAG: /* Loaded */ 3,
        _0: items,
        _1: cursor,
        _2: more
      });
    }
  }));
}

function dispatch(t, id) {
  if (/* tag */ typeof id !== "object" && typeof id !== "function") {
    if (id === /* Close */ 0) {
      cancel(t);
      return emit(t, /* Close */ 0);
    }
    
  } else if (id.TAG === /* Open */ 0) {
    const match = Curry._1(t.model, undefined).account_form;
    const match$1 = account(t, id._0);
    if (match !== undefined && match$1 !== undefined && !match.pending && !match.loading && match.selected === undefined && match$1.status !== "revoked") {
      return load(t, match$1, false);
    } else {
      return;
    }
  }
  const form$1 = form(t);
  if (form$1 === undefined) {
    return;
  }
  if (Mapre_web__Web_account_sharing_model.busy(form$1)) {
    return;
  }
  const match$2 = account(t, form$1.account_id);
  if (!/* tag */ (typeof id !== "object" && typeof id !== "function")) {
    if (id.TAG === /* Change */ 1) {
      let workspace_id = id._0;
      let shared = id._1;
      const account$1 = account(t, form$1.account_id);
      if (account$1 === undefined) {
        return;
      }
      if (!(account$1.status !== "revoked" && Stdlib__List.exists((function (w) {
          return w.id === workspace_id;
        }), form$1.items))) {
        return;
      }
      emit(t, /* Pending */ 3);
      const body = JSON.stringify(Js__Js_dict.fromList({
        hd: [
          "expected_version",
          account$1.version
        ],
        tl: /* [] */ 0
      }));
      return request(t, account$1.id, shared ? "PUT" : "DELETE", body, "/shares/" + workspace_id, (function (json) {
        const current = Mapre_web__Web_accounts_model.decode(Mapre_wire__Json.get(json, "connection"));
        if (current.id !== account$1.id) {
          throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
              MEL_EXN_ID: Mapre_wire__Json.Invalid,
              _1: "unexpected_connection"
            });
        }
        Curry._1(t.emit, {
          TAG: /* Accounts */ 41,
          _0: {
            TAG: /* Updated */ 14,
            _0: current
          }
        });
        emit(t, {
          TAG: /* Saved */ 4,
          _0: workspace_id,
          _1: shared
        });
        Curry._1(t.changed, undefined);
      }));
    } else {
      return;
    }
  }
  switch (id) {
    case /* Refresh */ 1 :
      if (match$2 !== undefined) {
        return load(t, match$2, false);
      } else {
        return;
      }
    case /* More */ 2 :
      if (match$2 !== undefined && form$1.cursor !== undefined) {
        return load(t, match$2, true);
      } else {
        return;
      }
    default:
      return;
  }
}

function create(emit, model, failure, changed) {
  return {
    emit,
    model,
    failure,
    changed,
    generation: 0,
    controller: new AbortController()
  };
}

export {
  create,
  cancel,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
